export default {
  text: '{0} has updated documents that you have previously accepted.',
  showAgreementButton: 'Show conditions',
  acceptButton: 'Accept them again'
}